import { Tabs } from 'antd';
import { Outlet, useLocation, useNavigate } from 'react-router';
import tw from 'twin.macro';

import { PATH } from '@/Route';

const MarketingProductIndex = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div>
      <Tabs
        activeKey={location.pathname}
        items={[
          {
            key: PATH.MARKETING_PRODUCT.INDEX,
            label: '상품 리스트',
          },
          {
            key: PATH.MARKETING_PRODUCT.ORDER_HISTORY,
            label: '신청 내역',
          },
        ]}
        onChange={(value) => navigate(value)}
      />

      <div css={tw`mt-[16px] w-full`}>
        <Outlet />
      </div>
    </div>
  );
};

export default MarketingProductIndex;
